import React from 'react';
import Review from './review';
import '../css/Service.css';

function IndustrialWaste() {
  return (
    <div className="service-page">
      <div className="service-banner">
        <img src={'/img_6.jpg'} alt="Industrial Waste Banner" className="service-banner-img" />
        <div className="service-banner-overlay"></div>
        <div className="service-banner-content">
          <h1>Industrial Waste</h1>
        </div>
      </div>

      <header className="service-header">
        <h1>INDUSTRIAL WASTE</h1>
        <p>
          We provide comprehensive management, transportation and disposal services for a wide array of industrial waste streams.
        </p>
      </header>

      <section className="service-content">
        <div className="service-content-left">
          <h2>We have programs for:</h2>
          <ul className="feature-list">
            <li>Industrial waste management — including waste diversion and minimization.</li>
            <li>Industrial waste recycling — reclaim, reuse or beneficial reuse of solvents and other chemicals.</li>
            <li>Industrial waste disposal — disposal under RCRA guidelines for each waste stream.</li>
            <li>Disposition of unused chemicals — we find buyers for unused and unwanted chemicals.</li>
          </ul>

          <p>
            Our teams manage identification, transport, and final disposition for many industry sectors.
          </p>

          <h3>Industries served include:</h3>
          <ol className="feature-list">
            <li>Agriculture; plantations; other rural sectors</li>
            <li>Basic metal production</li>
            <li>Chemical industries</li>
            <li>Food; drink; tobacco</li>
            <li>Wood; pulp and paper</li>
            <li>Health services</li>
            <li>Hotels</li>
            <li>Mechanical and electrical engineering</li>
            <li>Oil and gas production; oil refining</li>
            <li>Shipping; ports; fisheries</li>
            <li>Textiles; clothing; leather; footwear</li>
            <li>Transport equipment manufacturing</li>
            <li>And many more...</li>
          </ol>

          <div className="service-cta">
            <a href="/contact" className="btn btn-primary">Request Industrial Waste Services</a>
          </div>
        </div>

        <aside className="service-content-right">
          <div className="specialty-card">
            <h3>Capabilities</h3>
            <ul className="specialty-list">
              <li>RCRA-compliant disposal and manifesting</li>
              <li>Nationwide transport and logistics</li>
              <li>On-site characterization and profiling</li>
              <li>Customized waste minimization programs</li>
            </ul>
          </div>
        </aside>
      </section>

      <Review />
    </div>
  );
}

export default IndustrialWaste;
